import { Injectable } from '@angular/core';

import { NecLocalStorageService } from '../../service/localStorage/local-storage.service';

const TENANT_ADMIN_AUTH_INFO = 'tenantAdminAuthInfo';
/**
 * æä¾æ´æ°Headerä¸­ä¿¡æ¯çæ¹æ³
 */
@Injectable()
export class NecTenantAdminAuthCodeService {

  constructor(
    private ls: NecLocalStorageService
  ) { }

  setTenantAdminAuthInfo(authInfo: any) {
    this.ls.set(TENANT_ADMIN_AUTH_INFO, authInfo);
  }

  getTenantAdminAuthInfo() {
    return this.ls.get(TENANT_ADMIN_AUTH_INFO);
  }

  deleteTenantAdminAuthInfo() {
    this.ls.del(TENANT_ADMIN_AUTH_INFO);
  }

}
